
import {Component} from 'vue-property-decorator';
import {deleteArchivedSession, fetchArchivedSessions} from '@/repositories/api/ArchivedSessionApi';
import SessionPendingView from '@/views/sessions/SessionPendingView.vue';

@Component
export default class SessionArchivedView extends SessionPendingView {
  title = 'Archivé';
  fetchItems: Function = fetchArchivedSessions;
  protected viewLabel = 'Archivé';
  protected sessionDeleter: Function = deleteArchivedSession;
}
